export default __webpack_public_path__ + "static/media/AzoSansRegular.a74cb494.ttf";